import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [iframeLoading, setIframeLoading] = useState(true);
  const [messageSent, setMessageSent] = useState(false);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
  }, []);

  const handleMessage = () => {
    setTimeout(() => {
      setIframeLoading(false);
    }, 1000);
  };

  const messageData = JSON.stringify({
    email: process.env.REACT_APP_CITIIQ_USERNAME,
    secret: process.env.REACT_APP_CITIIQ_SECRET
  });

  return (
    <div className='App'>
      <p
        style={
          messageSent
            ? {
                display: 'none'
              }
            : {}
        }
      >
        African Cities demo - CitiIQ Dashboard
      </p>
      {iframeLoading && (
        <div className='lds-ring'>
          <span className='label'>loading</span>
          <div className='spinner'></div>
          <div className='spinner'></div>
          <div className='spinner'></div>
        </div>
      )}
      <a
        style={{ display: iframeLoading ? 'none' : messageSent ? 'none' : '' }}
        className='App-link'
        href={`${process.env.REACT_APP_CITIIQ_DOMAIN}`}
        target='_self'
        rel='noopener'
        onClick={e => {
          e.preventDefault();
          // handles a bug in safari which does not post the message the first time
          // https://stackoverflow.com/questions/42632188/how-to-send-cross-domain-post-message-in-safari
          try {
            document
              .getElementById('CitiIQ')
              .contentWindow.postMessage(messageData, '*');
          } catch (e) {
            document
              .getElementById('CitiIQ')
              .contentWindow.postMessage(messageData, '*');
          }
          setMessageSent(true);
        }}
      >
        Click to Login
      </a>
      <iframe
        title='CitiIQ Login'
        style={{ display: messageSent ? '' : 'none' }}
        frameBorder='0'
        width='100%'
        height='600px'
        id='CitiIQ'
        src={`${process.env.REACT_APP_CITIIQ_DOMAIN}/login`}
      ></iframe>
    </div>
  );
}

export default App;
